import { isSafeLocalPath } from "@/lib/safeLocalPath";

/**
 * Where the member goes after signing in on /landing: the `deviceLinkReturn`
 * path when it is a path on our site, otherwise onboarding. It was accepted if
 * it merely started with "/", which let `//evil.com` send members off-site
 * straight after a real sign-in (security review 2026-09-26, M3).
 */
export function resolvePostAuthRedirect(deviceLinkReturn: string | null | undefined): string {
  return isSafeLocalPath(deviceLinkReturn) ? deviceLinkReturn : "/onboarding/check";
}
